import dayjs from 'dayjs'
import 'dayjs/locale/id'

dayjs.locale('id')

// import updateLocale from 'dayjs/plugin/updateLocale'
// dayjs.extend(updateLocale)

// dayjs.updateLocale('en', {
//   weekdays: ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'],
// })

export default dayjs
